// What's new, per release. Keyed by major.minor only — a patch is a bug fix and announces nothing.
// Only the newest release the user hasn't seen is shown, so older entries can be dropped once a newer one ships.
// `users` is what everyone sees; `admins` is what admins see on top of it, listed after.
// A release with no list for someone's role shows them nothing. `es` has the same notes in Spanish —
// the tests require it for every release.
//
// {
//   version: 'x.y',
//   users: ['Play any chart with drums under it'],
//   admins: ['Pick a rhythm style per part'],
//   es: { users: [...], admins: [...] },
// },
// At most 3 points per release, counting users and admins together, so nobody is overwhelmed.
const releaseNotes = [
  {
    version: '5.2',
    users: ['Practice any song with its YouTube video: repeat a part as many times as you like, and slow it down'],
    admins: [
      'On phones and tablets, editing a song is now split into Info, Lyrics and Parts tabs. Tap one or swipe to switch',
    ],
    es: {
      users: [
        'Practica cualquier canción con su video de YouTube: repite una parte cuantas veces quieras y bájale la velocidad',
      ],
      admins: [
        'En teléfonos y tabletas, editar una canción ahora se divide en pestañas: Información, Letra y Partes. Toca una o desliza para cambiar',
      ],
    },
  },
  {
    version: '5.1',
    users: [
      'Migrupo is now available in Spanish — change it in Settings',
      'Chord charts now play with a full band that follows the energy of each song',
      'Services show how long they will last once every song has a chart',
    ],
    es: {
      users: [
        'Migrupo ya está disponible en español: cámbialo en Ajustes',
        'Los cifrados ahora suenan con una banda completa que sigue la energía de cada canción',
        'Los servicios muestran cuánto duran cuando todas sus canciones tienen cifrado',
      ],
    },
  },
];

export default releaseNotes;
